<template>
	<ion-button
		:disabled="!props.user.email"
		size="small"
		color="medium"
		@click="confirmResetPassword"
	>
		{{ $t("user-management.send-password-reset") }}
	</ion-button>
</template>
<script setup lang="ts">
	import { useSendPasswordReset } from "@/composables/useSendPasswordReset";
	import { sendToast } from "@/utils/sendToast";
	import { alertController, IonButton } from "@ionic/vue";
	import { GVAUserPrivilegedDTO } from "seedgreen-shared/dtos/GVAUserDTO";
	import { useI18n } from "vue-i18n";

	const props = defineProps<{
		user: GVAUserPrivilegedDTO;
	}>();

	const { t } = useI18n();
	const sendPasswordReset = useSendPasswordReset();
	async function confirmResetPassword() {
		if (!(props.user instanceof GVAUserPrivilegedDTO)) return;

		const resetUser = props.user as GVAUserPrivilegedDTO;
		if (!resetUser.email) return;

		const alert = await alertController.create({
			header: t("user-management.password-reset-header"),
			subHeader: t("user-management.password-reset-subheader"),
			message: t("user-management.password-reset-message"),
			buttons: [
				{
					text: t("common.cancel"),
					role: "cancel",
				},
				{
					text: t("user-management.send-reset"),
					handler: async () => {
						if (!resetUser.email) return;
						await sendPasswordReset(resetUser.email);
						await sendToast(
							t("user-management.password-reset-success"),
							3000,
							"success",
						);
					},
				},
			],
		});
		await alert.present();
	}
</script>
